module.exports = __webpack_public_path__ + "static/media/dinosaur(22).f30aba3a.PNG";